import { useRecoilCallback } from "recoil";
import { DenseOrderSheetSet } from "@/features/order-sheets/order-sheet.type";
import {
  agencyOrderSheetSetRowsMutateId,
  agencyOrderSheetSetRowsState,
} from "@/features/order-status/recoils/agency-order-sheet-set-rows-state";
import {
  applySameStatusCheckableLock,
  createAgencyOrderSheetSetRows,
} from "@/features/order-status/helpers/agency-order-sheet-set-row-helper";
import { AgencyOrderSheetSetRow } from "@/features/order-status/order-sheet-set-row.type";
import { GridMapperToRowOption } from "@/features/ui/grid-row/gird-mapper";

export default function useAgencyOrderSheetSetRows() {
  const setRows = useRecoilCallback(
    ({ set, snapshot }) =>
      (
        orderSheetSets?: DenseOrderSheetSet[],
        option?: GridMapperToRowOption
      ) => {
        set(agencyOrderSheetSetRowsState, (prev) => {
          const rows = createAgencyOrderSheetSetRows(
            orderSheetSets,
            prev,
            option
          ) as AgencyOrderSheetSetRow[] | undefined;
          // 체크가 보존된 경우(상태 변경 후 새로고침 등) 같은 상태끼리만 선택 가능하도록 잠금 재계산.
          if (rows) {
            applySameStatusCheckableLock(rows);
          }
          return rows;
        });
      },
    []
  );

  const mutateRows = useRecoilCallback(
    ({ set }) =>
      () => {
        set(agencyOrderSheetSetRowsMutateId, (prev) => {
          return prev + 1;
        });
      },
    []
  );

  return {
    setRows,
    mutateRows,
  };
}
